'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

const YandexAdsScript = () => {
  const [shouldLoadAds, setShouldLoadAds] = useState(false);

  useEffect(() => {
    const interactionEvents = ['scroll', 'click', 'mousemove', 'touchstart'];
    let adsTimer: NodeJS.Timeout;
    let interactionTimer: NodeJS.Timeout;

    const loadAds = () => {
      setShouldLoadAds(true);
      interactionEvents.forEach((event) => window.removeEventListener(event, loadAds));
      clearTimeout(adsTimer);
      clearTimeout(interactionTimer);
    };

    interactionTimer = setTimeout(() => {
      interactionEvents.forEach((event) => window.addEventListener(event, loadAds, { once: true }));
    }, 3000);

    adsTimer = setTimeout(() => {
      loadAds();
    }, 6000);

    return () => {
      interactionEvents.forEach((event) => window.removeEventListener(event, loadAds));
      clearTimeout(adsTimer);
      clearTimeout(interactionTimer);
    };
  }, []);

  if (!shouldLoadAds) return null;

  return (
    <>
      <Script id="yandex-ads-init" strategy="afterInteractive">
        {`window.yaContextCb = window.yaContextCb || [];`}
      </Script>
      <Script src="https://yandex.ru/ads/system/context.js" strategy="afterInteractive" />
    </>
  );
};

export default YandexAdsScript;
